export function checkHasBirdviewAttentionMore(groups) {
  return groups.some(group => group.count > group.items.length)
}

export function getBirdviewAttentionRequestId(item) {
  return item.requestId ?? item.id
}
